document.addEventListener("DOMContentLoaded", function() {
  const videoButton = document.querySelector('.image-with-video__videosection');
  const popupCloseButton = document.querySelector('.hide-data .close-popup');
  const popup = document.querySelector('.hide-data');

  // Function to pause all media elements
  function pauseAllMedia() {
    // Pause all YouTube videos
    document.querySelectorAll('.video-player__video').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    // Pause all Vimeo videos
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    // Pause all HTML5 videos
    document.querySelectorAll('video').forEach((video) => video.pause());
  }

  // Function to close the popup
  function closePopup() {
    popup.classList.remove('show');
  }

  // Event listener for the video button to show the popup
  videoButton.addEventListener('click', function() {
    popup.classList.add('show');
  });

  // Event listener for the popup close button
  popupCloseButton.addEventListener('click', function() {
    closePopup();
    pauseAllMedia();
  });

  // Event listener for the Escape key to close the popup and pause all media
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closePopup();
      pauseAllMedia();
    }
  });
});
